<template>
  <div v-if="data.purchaseProductCouponId" class="history contents">
    <div class="view">
      <dl class="claimDate">
        <dt>청약철회</dt>
        <dd>{{ data.withdrawDate }}</dd>
      </dl>
      <dl class="purchaseDate">
        <dt>구매완료</dt>
        <dd>{{ data.purchaseDate }}</dd>
      </dl>
      <dl class="purchaseNum">
        <dt>주문번호</dt>
        <dd>{{ data.purchaseId }}</dd>
      </dl>
      <ul class="listTypeCart">
        <li class="productItem">
          <list-item :product="data"></list-item>
        </li>
      </ul>
    </div>
    <div class="payInfo">
      <h2 class="subTitle">환불정보</h2>
      <div>
        <dl>
          <dt class="accessibilityHide">청약철회 처리일자</dt>
          <dd>{{ data.withdrawDate }}</dd>
        </dl>
        <dl>
          <dt>환불금액</dt>
          <dd>{{ (data.price ? data.price : 0).addComma() }}{{ data.currencyUnit }}</dd>
        </dl>
        <dl>
          <dt>환불수단</dt>
          <dd>{{ data.refundPaymentTypeName }}</dd>
        </dl>
        <dl>
          <dt>환불방법</dt>
          <dd>결제 취소</dd>
        </dl>
        <dl>
          <dt>환불상태</dt>
          <dd><span class="productStateRed"> {{ status }}</span></dd>
          <!-- <dd><span class="productStateGray">처리완료</span></dd> -->
        </dl>
      </div>
    </div>
    <ul class="msg">
      <li>청약철회신청 상태인 경우 자동 접수된 1:1 문의를 통해 서류 확인 후 처리 됩니다.<br>고객센터 1:1 문의 내역에서 상담사 답변을 확인해주세요.</li>
      <li>계좌 입금의 경우에는 환불상태가 처리완료로 변경된 후 최대 7일 이내 입금됩니다.</li>
    </ul>
  </div>
</template>



<script>
// getWithdrawDetail
import MyAPI from '@/api/my'
import ListItem from '@/views/my/ListItem'
import { covnertCancelStatus } from '@/utils'

export default {
  name: 'CancelView',
  components: {
    ListItem
  },
  props: {
    purchaseId: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      data: {},
      paymentType: {
        1: '카카오페이',
        2: '토스페이',
        3: 'PAYCO',
        4: '문화상품권',
        5: '신용카드'
      }
    }
  },
  computed: {
    status() {
      return this.data.withdrawStatus ? covnertCancelStatus(this.data.withdrawStatus) : ''
    }
  },
  mounted() {
    MyAPI.getWithdrawDetail(this.purchaseId, responseData => {
      this.data = responseData.data
    })
  }
}
</script>

<style lang="scss" scoped>
.history {
  .claimDate,
  .purchaseDate {
    padding: 0 16px;
    dt,
    dd {
      display: inline-block;
      font-size: 12px;
    }
    dt::after {
      content: '|';
      margin: 0 5px;
    }
  }
  .claimDate {
    padding-top: 7px;
    font-weight: bold;
  }
  .purchaseDate {
    padding-top: 9px;
    font-weight: normal;
  }
  .purchaseNum {
    font-size: 12px;
    padding-top: 9px;
    dt::after {
      margin: 0 5px;
    }
  }
  .payInfo {
    position: relative;
    dd {
      font-size: 13px;
    }
    dl:nth-child(1) {
      position: absolute;
      top: 17px;
      right: 16px;
      dd {
        font-size: 12px;
      }
    }
    dl:nth-child(2) {
      dd {
        font-weight: bold;
        font-size: 15px;
      }
    }
  }
}
</style>
